import { FacetNavigation, Facet, SectionGroup } from "./Filters";

const findSelectableFilters = (
  {
    brandFacets,
    categoryFacets,
    partFacets,
    specificationFacets,
    searchWithinFacet,
    partsCount,
    productsCount,
  }: FacetNavigation,
  showSearchWithinFilter: boolean
) => {
  const itemsAreSelectable = ({ sectionGroups }: Facet) =>
    !!sectionGroups?.some(({ groupItems }: SectionGroup) =>
      groupItems.some(({ isSelected }) => !isSelected)
    );

  const searchWithinIsSelectable =
    showSearchWithinFilter &&
    (!searchWithinFacet.sectionGroups ||
      searchWithinFacet.sectionGroups.length === 0) &&
    partsCount + productsCount >= 10;

  return Boolean(
    itemsAreSelectable(brandFacets) ||
      itemsAreSelectable(partFacets) ||
      itemsAreSelectable(specificationFacets) ||
      (categoryFacets.sectionGroups &&
        categoryFacets.sectionGroups.length > 1) ||
      searchWithinIsSelectable
  );
};

export default findSelectableFilters;
